import { AuthTypes } from 'enums';

export default function getAccessMethodFromAuthTypes(userAuth = []) {
    if (userAuth.indexOf(AuthTypes.MVPD) !== -1) {
        return 'Authenticated - ESPN';
    } else if (userAuth.indexOf(AuthTypes.ISP) !== -1) {
        return 'ISP';
    }
    return 'Not Authenticated';
};



// WEBPACK FOOTER //
// ./app/lib/auth/getAccessMethodFromAuthTypes.js